import React from "react";
import * as Styles from "./button.styles";

interface SecondaryButtonI {
  content: any;
  onClick?: () => void;
  disabled?: boolean;
  style?: any;
  color?: "success" | "error" | "warning";
  type?: "button" | "submit" | "reset" | undefined;
}

export function SecondaryButton(props: SecondaryButtonI) {
  return (
    <Styles.SecondaryButton
      disabled={props.disabled}
      onClick={props.disabled ? () => {} : props.onClick}
      style={props.style}
      color={props.color}
      type={props.type ?? "button"}
    >
      {props.content}
    </Styles.SecondaryButton>
  );
}
